import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../common/context/';
import { formatDate } from '../../../../utils/';
import { BaseConfirmModal } from '../BaseConfirmModal';
import { DeleteWorkshiftModalProps } from './DeleteWorkshiftModal.Props';

export const DeleteWorkshiftModal = ({
    isOpen,
    employee,
    startDate,
    endDate,
    setModalOpen,
    deleteWorkshiftsScheduling,
}: DeleteWorkshiftModalProps) => {
    const { langResources } = useContext(AppContext);

    return (
        <BaseConfirmModal
            isLoading={false}
            modalTitle={langResources['delete.workshift']['title']}
            onClose={() => {
                setModalOpen(false);
                window.localStorage.removeItem('selection-range');
            }}
            onSubmit={deleteWorkshiftsScheduling}
            isOpen={isOpen}
            isShowControls={true}
            textButton={langResources['basemodal.save.button']}
        >
            <div className='modal-body text-dark'>
                <h3 className='text-center mb-5 text-dark modal-title fw-bold'>
                    {langResources['delete.workshift']['modal.title']}
                </h3>
                <div className='d-flex justify-content-center'>
                    <div className='w-50'>
                        <h6 className='fw-bolder'>
                            {langResources['delete.workshift']['employee.label']}:
                        </h6>
                        <p className='text-muted'>
                            {employee?.map((emp) => (
                                <li key={emp.id}>
                                    {emp.text.toLowerCase().split('(')[0]}
                                </li>
                            ))}
                        </p>
                    </div>

                    <div>
                        <h6 className='fw-bolder'>
                            {langResources['delete.workshift']['start.date']}:{' '}
                        </h6>
                        <p className='text-muted' style={{ marginTop: -8 }}>
                            {formatDate(startDate)}
                        </p>

                        <h6 className='fw-bolder'>
                            {langResources['delete.workshift']['end.date']}:{' '}
                        </h6>
                        <p className='text-muted' style={{ marginTop: -8 }}>
                            {formatDate(endDate)}
                        </p>
                    </div>
                </div>
            </div>
        </BaseConfirmModal>
    );
};
